import { AttentionTypes } from '../../Definitions'
import { Pages } from '../../Navigation/Routers/root'
import { LangFile } from './'

const Texts:LangFile = {
  // #region | General
  autoReports: "auto rapporter",
  change: "skift",
  filterBy: "filtrer efter",
  from: "fra",
  no: "nej",
  noData: "ingen data",
  noOptions: "ingen valgmuligheder",
  of: "af",
  off: "Slukket",
  on: "Tændt",
  optional: "valgfri",
  page: "side",
  reset: "nulstil",
  required: "påkrævet",
  saveAlert: "Venligst gem eller afbryd rettelserne.",
  search: "Søg",
  select: "Vælg",
  success: "Succes",
  to: "til",
  useSelectedTime: "benyt valgt tidspunkt",
  yes: "ja",
  // #endregion

  languages: {
    en: "english",
    dk: "dansk",
    es: "español",
    de: "deutsch",
    ma: "mandarin"
  },

  cookie: {
    header: "cookies",
    context1: "Agrisys A/S benytter cookies til følgende formål:",
    context2: "Ved at klikke på “accepter alle” accepterer du vores brug af cookies.",
    purpose1: "For at understøtte websitets funktionalitet, for eksempel ved at huske dine indstillinger for cookies, foretrukne sprog, valutaer osv.",
    purpose2: "For at udføre statistisk analyse af din brug af websitet, for eksempel ved at måle, hvilken type indhold du ser på og klikker på. Ellers vil et minimum af cookies blive brugt, som er nødvendige for, at servicen kan fungere – for eksempel til at håndtere login og hente data fra Consys-platformen.",
    accept: "accepter nødvendige",
    acceptAll: "accepter alle"
  },

  // #region | Units
  units: {
    units: "enheder",
    capacity: "kapacitet",
    days: "dage",
    g: "g",
    hour: "time",
    hourAgo: "time siden",
    hours: "timer",
    hoursAgo: "timer siden",
    kg: "KG",
    minutAgo: "minut siden",
    minutesAgo: "minutter siden",
    min: "min",
    pct: "PCT",
    timeToday: "gang idag",
    timesToday: "gange idag",
    total: "total"
  },
  // #endregion

  // #region | Buttons
  buttons: {
    add: "tilføj",
    apply: "tildel",
    cancel: "afbryd",
    commit: "udfør",
    confirm: "bekræft",
    create: "opret",
    csv: "csv",
    deselectAll: "fravælg alle",
    details: "detaljer",
    edit: "ret",
    excel: "excel",
    filter: "filtrer",
    goBack: "gå tilbage",
    menu: "menu",
    move: "flyt",
    next: "næste",
    options: "muligheder",
    prev: "forrige",
    print: "print",
    resetFilters: "nulstil filtre",
    save: "gem",
    selectAll: "vælg alle"
  },
  // #endregion

  // #region | Menu Headers
  menuHeaders: {
    overview: "oversigt",
    globalMenu: "global menu",
    operations: "operationer",
    systemMenu: "system menu",
    attentions: "advarsler",
    quickEntry: "hurtig redigering",
    language: "sprog",
    [Pages.dashboard]: "dashboard",
    [Pages.kpi]: "kpi",
    [Pages.feedCurves]: "foderkurver",
    [Pages.feedCurve]: "foderkurve",
    [Pages.components]: 'komponenter',
    [Pages.componentsAlternatives]: "komponent alternativer",
    [Pages.mixtures]: "blandinger",
    [Pages.silos]: "siloer",
    [Pages.silosSettings]: "silo indstillinger",
    [Pages.animals]: "dyr",
    [Pages.animal]: "dyr",
    [Pages.animalsGroups]: "dyregrupper",
    [Pages.reports]: "rapporter",
    [Pages.report]: "rapport",
    [Pages.archive]: 'arkiv',
    [Pages.logbook]: "logbog",
    [Pages.globalSettings]: "indstillinger",
    [Pages.devices]: "enheder",
    [Pages.freeda_lf]: "oversigt",
    [Pages.freeda_lf_sections]: 'sektioner',
    [Pages.freeda_lf_settings]: 'indstilliner',
    [Pages.op_operations]: 'operationer',
    [Pages.op_quickEntry]: 'Hurtig redigering',
    [Pages.freeda_esf]: "oversigt",
    [Pages.freeda_esf_sections]: "sektioner",
    [Pages.freeda_esf_settings]: "indstillinger",
  },
  // #endregion

  // #region | User
  user: {
    userInformation: "bruger information",
    user: "bruger",
    userName: "Brugernavn",
    firstName: "Fornavn",
    lastName: "Efternavn",
    phone: "Telefon",
    email: "Email",
    password: "Kodeord",
    repeatPassword: "Gentag kodeord",
    country: "Land",
    address: "Adresse"
  },
  // #endregion

  // #region | Farm
  farm: {
    farmInformation: "Gård information",
    farmName: "Gård navn",
    city: "By",
    street: "Vej",
    phone: "Telefon",
    vat: "CVR",
    email: "Email"
  },
  // #endregion

  // #region | Milestones
  milestones: {
    general: {
      milestone: "Milepæl",
      milestones: "Milepæle",
      noMilestoneFound: "Ingen milepæl fundet",
      animalsInMilestones: "Dyr i milepæle",
      latestMilestone: "Nuv. milepæl",
      milestoneDay: "Nuv. milepælsdag",
      newMilestone: "Ny milepæl"
    },
    defaultMilestones: {
      farrowing: "Farring",
      insemination: "Inseminering",
      weaning: "Fravænning",
      movedToFarrowing: "Flyttet til farring"
    }
  },
  // #endregion

  // #region | Devices
  devices: {
    devices: "enheder",
    name: "navn",
    cpuId: "cpu id",
    type: "Type",
    connection: "forbindelse",
    system: "system",
    noControllersFound: "ingen lan controllers fundet",
    lanControllers: "lan controllers",
    newLcBoard: "nyt lc board",
    boardName: "board navn",
    noIoBoards: "ingen i/o boards fundet",
    ioBoards: "i/o boards",
    newIoBoard: "nyt i/o board",
    layout: "udseende",
    horizontal: "Horisontal",
    vertical: "Vertikal",
    asc: "Stigende",
    desc: "Faldende",
    columns: "kolonner",
    rows: "rækker",
    order: "rækkefølge",
    direction: "retning",
    chooseIo: "vælg i/o",
    remainingInputs: "resterende indgange",
    remainingOutputs: "resterende udgange",
    aicoIo: "I/O Board",
    output: "Udgang",
    input: "Indgang",
    board: "board",
    moveBoard: "flyt board",
    noTerminals: "Ingen terminaler",
    terminalPort: "Terminal port",
    pen: "Sti",
    ioSpecifications: "i/o specifikationer"
  },
  // #endregion

  // #region | System Controls
  systemControls: {
    general: {
      startSystem: "start system",
      systemControls: "system styring",
      emergencyStop: "nødstop",
      startAll: "start alle",
      startSection: "start sektion",
      startSelected: "start valgte",
      calibrateSection: "kalibrer sektion",
      calibrateSelected: "kalibrer valgte",
      emptySection: "tøm sektion",
      emptySelected: "tøm valgte",
      clickPen: "Klik på de stier du vil vælge",
      unClickPen: "Klik på de stier du vil fravælge",
      orSelectAll: "Eller vælg alle",
      orDeselectAlle: "Eller fravælg alle",
      problem: "problem",
      problems: "problemer",
      warning: "advarsel",
      warnings: "advarsler",
      attentions: "advarsler",
      attentionType: "Advarselstype",
      systemState: "Systemtilstand",
      staticFeeding: "Statisk Fodring",
      resolvedWeight: "Målt fodermængde",
      noPensSelected: "Ingen stier valgt",
      feeding: "Fodrer",
      feedingFailed: "Fodring fejlede",
      calibrating: "Kalibrerer",
      calibratingFailed: "Kalibrering fejlede",
      changeTime: "Skift varighed",
      emptyingFor: "Tømmer i",
      emptyingFailed: "Tømning fejlede",
      confirmStop: "Vil du lave et nødstop af systemet?"
    },
    states: {
      [AttentionTypes.good]: "Kører",
      [AttentionTypes.neutral]: "Slukket",
      [AttentionTypes.warning]: "Advarsel",
      [AttentionTypes.alert]: "Alarm"
    }
  },
  // #endregion
  
  // #region | Params
  params: {
    animal: "Dyr",
    animalId: "Dyrenr.",
    location: "Lokation",
    feedCurve: "Foderkurve",
    group: "Gruppe",
    condition: "Tilstand",
    removeAnimals: "Flyt dyr",
    resetTotalConsumed: "Nulstil total forbrug",
    manualFeedStart: "Manuel fodringsstart",
    clearCalendarEvents: "Tøm kalender begivenheder",
    insemination: "Inseminering",
    weaning: "Fravænning",
    farrowing: "Farring",
    pregnancyCheck: "Drægtighedscheck",
    birthDate: "Fødselsdag",
    pregnant: "Drægtig",
    notPregnant: "Ikke drægtig",
    responderNo: "Respondernr.",
    lifeNo: "Livsnr.",
    animalType: "Dyretype",
    milestone: "Milepæl",
    system: "System",
  },
  // #endregion

  // #region | Feed
  feed: {
    general: {
      feed: "foder",
      feeding: "Fodring",
      remainingToday: "Levnet idag",
      remainingYesterday: "Levnet igår",
      waterUseToday: "Vandforbrug idag",
      notFed: "Ikke fodret sidste 2 dage",
      feedLastDays: "sidste 10 dage",
      currentProgress: "nuværende udvikling",
      fedLastPeriod: "fodret seneste periode",
      fedTotal: "fodret total",
      feedConsumption: "foderforbrug",
      feedBalance: "foderbalance"
    },
    feedCurve: {
      feedCurve: "Foderkurve",
      active: "aktiv",
      noFeedCurve: "ingen foderkurve fundet",
      default: "standard",
      minFeedSpeed: "minimum fodringshastighed (g/min)",
      maxFeedSpeed: "maximum fodringshastighed (g/min)",
      feedSpeed: "fodringshastighed",
    },
    feedCorrection: {
      increased: "forøget",
      decreased: "reduceret",
      disabled: "deaktiveret",
      feedCorrection: "Foder Korrigering",
      feedCorrections: "foder korrigeringer",
    },
    feedSkip: {
      feedSkip: "foderskip",
      skipFeeding: "skip fodring",
      noSkip: "ingen foderskip",
      skipForNow: "for nu",
      planSkip: "planlæg",
      planFeedSkip: "planlæg foder skip",
      standardSkip: "standard",
      startFeeding: "start fodring",
      invalidDay: "ugyldig dag",
      invalidTime: "ugyldig tid",
      endDateBeforeStartDate: "slutdatoen er tidligere end startsdatoen",
      endTimeBeforeStartTime: "sluttidspunktet er tidligere end startstidspunktet",
      timeSpan: "tidsrum",
      timeAmount: "tidsmængde",
      startDate: "startsdato",
      endDate: "slutdato",
      startTime: "startstidspunkt",
      endTime: "sluttidspunkt",
      plannedSkip: "planlagt skip"
    }
  },
  // #endregion

  // #region | Login Flow
  loginFlow: {
    def: {
      cloudView: "cloud visning",
      operationsView: "operations visning",
      goToSiteList: "Gå til side listen",
      switchToOperations: "Skift til operations visning",
      switchToCloud: "Skift til cloud visning"
    },
    login: {
      login: "log ind",
      logOut: "Log ud",
      welcomeBack: "velkommen tilbage",
      notRegisteredYet: "Endnu ikke registreret",
      createNewuser: "opret ny bruger",
      forgotPassword: "Glemt kodeord",
      resetPassword: "nulstil kodeord",
      missingUserName: "brugernavn mangles",
      missingPassword: "kodeord mangles",
      couldNotLogin: "kunne ikke logge ind",
      noSitesFound: "ingen sider fundet"
    },
    forgotPassword: {
      text: "Hvis der ikke er tilknyttet en e-mail til brugernavnet, bedes du kontakte supporten for yderligere hjælp.",
      text2: "Luk venligst ikke dette vindue, før nulstillingsprocessen er færdig.",
      noEmail: "Ingen email tilknyttet",
      contactSupport: "kontakt supporten",
      usernameRequired: "brugernavn nødvendig",
      noUsernameFound: "brugernavn eksisterer ikke"
    },
    resetPassword: {
      text: `En midlertidig kode er blevet sendt til din email, venligst indsæt det herunder for at oprette et nyt kodeord.`,
      temporaryCode: "Midlertidig kode",
      newPassword: "Nyt kodeord",
      repeatPassword: "Gentag nyt kodeord",
      createNewPassword: "opret nyt kodeord",
      contactSupport: "kontakt supporten",
      noPasswordRevieved: "Modtog du ikke en midlertidig kode",
      newPasswordFail: "kunne ikke oprette nyt kodeord"
    },
    createUser: {
      newUser: "ny bruger",
      missingUserName: "brugernavn mangles",
      missingPassword: "kodeord mangles",
      missingRepeatPassword: "venligst gentag kodeord",
      passwordMismatch: "kodeordene matcher ikke"
    },
    chooseSite: {
      chooseSite: "vælg side",
      siteName: "sidenavn",
      domain: "domæne",
      id: "id",
      tools: "tools"
    }
  },
  // #endregion

  // #region | Feed Curve pages
  feedCurvePages: {
    feedCurves: {
      copyFeedCurve: "kopier foderkurve",
      createFeedCurve: "opret foderkurve",
      createFeedCurveFromScratch: "Opret foderkurve fra bunden",
      feedCurveDetails: "foderkurvedetaljer",
      newFeedCurve: "ny foderkurve",
      feedCurveName: "foderkurve navn",
      fromFeedCurve: "fra foderkurve"
    },
    components: {
      components: "komponenter",
      emptyText: "ingen komponenter fundet",
      name: "komponent navn",
      readyMixture: "klar til brug",
      priority: "prioritet",
      ds: "ts",
      energy: "energi",
      protein: "protein"
    },
    feedCurve: {
      spreading: "spredning",
      settings: "indstillinger",
      day: "dag",
      watchFeedCurve: "se foderkurve",
      doNotPassFeed: "Overfør ikke foder",
      passFeed: "Overfør foder",
      noStimuli: "Ingen stimuli",
      addStimuli: "Tilføj stimuli",
      singleStimuli: "Enkelt stimuli",
      repeatStimuli: "Gentag stimuli",
      feedSpeed: "Feed Speed (g/min)",
      maxAmount: "maksimal periode mængde (kg)",
      remainingFeed: "tilbageværende foder",
      maxFeedToPass: "maksimal antal KG til overførsel",
      feedStimuli: "foderstimuli",
      minutesApart: "minutter imellem",
      addTime: "tilføj tidspunkt",
      saveChanges: "gem ændringer",
      resetChanges: "nulstil ændringer"
    }
  },
  // #endregion

  // #region | Animal pages
  animalPages: {
    animals: {
      animals: "dyr",
      emptyText: "ingen dyr fundet",
      quickEntry: "hurtig redigering",
      newAnimal: "nyt dyr",
      viewChanges: "ændringer",
      action: "handling",
      selectAnimals: "vælg dyr",
      missingAnimalNo: "dyrenr. mangles",
      missingResponderNo: "respondernr. mangles"
    },
    animalGroups: {
      group: "gruppe",
      numberOfAnimals: "Antal Dyr",
      createGroup: "opret gruppe",
      newGroup: "ny gruppe",
      groupName: "gruppe navn",
    },
    animal: {
      animal: "dyr",
      basicInfo: "basis info",
      noAnimalSelected: "ingen dyr valgt",
      noAnimalsSelected: "intet dyr valgt",
      addAnimal: "tilføj dyr",
      addAnimalToPen: "tilføj dyr til sti",
      pen: "sti",
      moveAnimal: "flyt dyr",
      moveAnimals: "flyt dyr",
      moveAnimalFromPen: "flyt dyr til sti",
      goToAnimal: "gå til dyrets side",
      totalCycleDay: "total cyklus dag",
      marking: "mærkning",
      events: "begivenheder",
      eventName: "Navn",
      eventDate: "Dato",
      eventNote: "Note",
      noTimeline: "ingen tidslinje fundet",
      addEvent: "tilføj begivenhed",
      timeline: "tidslinje",
      viewTimeline: "vis tidslinje",
      born: "født",
      timelineShows: "tidslinjen viser paritet",
      parity: "paritet",
    }
  },
  // #endregion

  // #region | Report pages
  reportPages: {
    reports: {
      template: "Skabelon",
      templateName: "skabelon navn",
      addTemplate: "tilføj skabelon",
      copyTemplate: "kopier skabelon",
      createReport: "opret rapport",
      createNewReport: "Start en ny rapport fra bunden",
      newTemplate: "ny skabelon",
      newReport: "ny rapport",
      dataLevel: "data level",
      filterParameter: "filter parameter",
      dataParameter: "data parameter",
      reportName: "rapport navn",
      archiveReport: "arkiver rapport",
      startDate: "startsdato",
      endDate: "slutsdato",
      showInReport: "Vis i rapporten",
      fromTemplate: "fra skabelon",
      noReportFound: "ingen rapport fundet",
      noDataParameterFound: "intet data parameter fundet",
      unknownCondition: "ukendt tilstand",
      unknownAnimalGroup: "ukendt gruppe",
      noFilterParameterFound: "intet filter parameter fundet",
      saveAsTemplate: "Save as Template",
    },
    report: {
      report: "rapport",
      editReport: "ret rapport",
      unArchiveReport: "fjern fra arkiv",
      saveAsTemplate: "gem som skabelon",
    },
    archive: {
      archive: "arkiv",
      filterByNumber: "rapport nummer",
      filterByName: "rapport navn alfabetisk",
      archivedReport: "Arkiveret rapport",
      noStartDateFound: "Ingen startsdato fundet",
      noEndDateFound: "Ingen slutsdato fundet",
    }
  },
  // #endregion

  // #region | Global Settings pages
  globalSettingsPages: {
    globalSettings: {
      imperial: "Imperial",
      metric: "Metrisk",
      saveChanges: "gem ændringer",
      discardChanges: "kasser ændringer",
      userManagement: "bruger administration",
      timeZone: "tidszone",
      feedDayStart: "foderdagsstart",
      remove: "fjern"
    }
  },
  // #endregion

  // #region | Location Feeder Pages
  locationFeederPages: {
    locationFeeder: {
      sections: "sektioner",
      pens: "stier",
      animals: "dyr",
      sectionNo: "Sektionsnr.",
      pen: "Sti",
    },
    sections: {
      section: "sektion",
      map: "kort",
      animalAmount: "antal dyr",
      penValueHeaders: "hold musen på en værdi for at se kolonne type",
      sectionNotFound: "sektion ikke fundet ",
      emptyPen: "Tom sti",
      feeder: "foderautomat",
      inThisPen: "i denne sti",
      activations: "aktiveringer",
      lastActivated: "sidst aktiveret",
      newSection: "ny sektion",
      sectionName: "sektionsnavn",
      firstPenNo: "første sti nr.",
      penAmount: "antal stier",
      clickOnPen: "Klik på en sti for at tilføje eller fjerne den igen",
      penContent: "sti indhold",
      feederOnly: "Kun foderautomat",
      water: "Vand",
      activator: "Aktivator",
      feederOutput: "Foderautomat udgang",
      waterOutput: "Vand udgang",
      activatorInput: "Aktivator indgang",
      since: "siden",
      redirect: "Dette vil viderestille dig til dyresiden.",
      expand: "Udvid",
      collapse: "Skjul"
    },
    settings: {
      dailyRotation: "daglig rotation",
      dailyRotationDisclaimer: "nb: hvis systemet er slukket, vil en daglig rotation sørge for at vedligeholde motoren.",
      feedInSilos: "foder i siloer",
      attentionLimit: "advarselsgrænse"
    }
  },
  // #endregion

  // #region | ESF Walk Through Pages
  esfWalkThroughPages: {
    esfWalkThrough: {
    },
    sections: {
      station: "station",
      feedMotor: "foder motor",
      feedSensor: "foder sensor",
      gateMotor: "låge motor",
      gateSensor: "låge sensor",
      inThisStation: "i denne station",
      previously: "tidligere",
      feedComponents: "foder komponenter",
      stationLastDays: "sidste 10 dage",
      stationLog: "log"
    },
    settings: {
    }
  },
  // #endregion
  
  // #region | Operations Pages
  operationsPages: {
    location: "lokation",
    system: "system",
    section: "sektion",
    inThisPen: "i denne sti",
    today: "i dag",
    pen: "sti",
    since: "siden",
    day: "Dag",
    moveAnimal: "flyt dyr",
    newLocation: "ny lokation"
  }
  // #endregion
}
export default Texts